import React from "react";
import { CreditCardOutlined } from "@mui/icons-material"; // Material-UI'dan bir kredi kartı ikonu eklenmiştir.

const SavedCard = ({ cardType, bank, cardNumber, name }) => {
  return (
    <div className="flex items-center p-4 bg-gray-50 rounded-lg shadow-sm mb-4">
      {/* Kart İkonu */}
      <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mr-4">
        <CreditCardOutlined className="text-blue-500 text-2xl" /> {/* Modern kredi kartı ikonu */}
      </div>
      {/* Kart Detayları */}
      <div className="grid grid-cols-4 gap-4 w-full">
        <div>
          <p className="text-xs text-gray-500">Card Type</p>
          <p className="text-sm font-medium">{cardType}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Bank</p>
          <p className="text-sm font-medium">{bank}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Card Number</p>
          <p className="text-sm font-medium">{cardNumber}</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Name</p>
          <p className="text-sm font-medium">{name}</p>
        </div>
      </div>
    </div>
  );
};

export default SavedCard;
